"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var marginBottom = '20px';
var createHeadlines = function createHeadlines(baseTheme) {
  return {
    headline: {
      '01': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['5xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['7xl']
        }
      },
      '02': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['4xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['6xl']
        }
      },
      '03': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['3xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['5xl']
        }
      },
      '04': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['2xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['3xl']
        }
      },
      '05': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.xl,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['2xl']
        }
      },
      '06': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.xl,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['2xl']
        }
      },
      '07': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.lg,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.xl
        }
      },
      '08': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.lg,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.xl
        }
      }
    }
  };
};
var createBody = function createBody(baseTheme) {
  return {
    body01: {
      lg: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.md,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.xl,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.lg
        }
      },
      md: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.sm,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.md
        }
      },
      sm: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.xs,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.sm
        }
      }
    },
    body02: {
      lg: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.md,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.xl,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.lg
        }
      },
      md: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.sm,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.md
        }
      },
      sm: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.xs,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.sm
        }
      }
    }
  };
};
var JvTypographyTheme = function JvTypographyTheme(baseTheme) {
  return {
    typographyName: 'typography-jv',
    typographyVersion: '1.0.0',
    typo: _objectSpread(_objectSpread(_objectSpread({}, createHeadlines(baseTheme)), createBody(baseTheme)), {}, {
      lead: {
        text: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.xl,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.xl,
          textTransform: baseTheme.font.transform.uppercase,
          marginBottom: marginBottom
        }
      },
      caption: {
        '01': {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        },
        '02': {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      button01: {
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      button02: {
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      link: {
        xl: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xl,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size['2xl']
          }
        }
      },
      link01: {
        lg: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.md,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.xl,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.lg
          }
        },
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.sm,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.md
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        }
      },
      link02: {
        lg: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.md,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.xl,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.lg
          }
        },
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.sm,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.md
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        }
      }
    })
  };
};
var _default = exports["default"] = JvTypographyTheme;